var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { config } from '../../../../../config/config';
import { BaseComponent } from '../../../../common/components/base.component';
import { isNullOrUndefined } from '../../../../common/extensions';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { EventSpiderModalData } from './event.spider.modal.provider';
import { SelectComponent } from '../../../../common/components/select/select.component';
import { timezoneConfig } from '../../../../../config/timezone';
import { finalize, map, startWith } from 'rxjs/operators';
import { EventTimeService } from '../../../../services/event.time.service';
import { AddSpiderEvenetsModalComponent } from '../../add.spider.events.modal/add.spider.events.modal.component';
import { AddSpiderEventsModalActions, AddSpiderEventsModalData, } from '../../add.spider.events.modal/add.spider.events.modal.provider';
import { SchedulerApiService } from '../../../../services/scheduler.api.service';
import { ModalService } from '../../../../common/services/modal.service';
import { MultipleFieldsComponent } from '../../../../common/components/multiple.fields/multiple.fields.component';
import { SerpConfig } from '../../../../models/admin/serp.config';
import { SetEventPageTagModalComponent } from './set.eventpage.tag.modal/set.eventpage.tag.modal.component';
import { ConfirmModalActions, ConfirmModalData, } from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { AddEventbriteEvenetsModalComponent } from '../../add.eventbrite.events.modal/add.eventbrite.events.modal.component';
import { AddEventbriteEventsModalActions, AddEventbriteEventsModalData, } from '../../add.eventbrite.events.modal/add.eventbrite.events.modal.provider';
var EventSpiderModalComponent = /** @class */ (function (_super) {
    __extends(EventSpiderModalComponent, _super);
    function EventSpiderModalComponent(fb, accountApiService, alertify, formBuilder, modalService, dialog, schedulerApiService, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.accountApiService = accountApiService;
        _this.alertify = alertify;
        _this.formBuilder = formBuilder;
        _this.modalService = modalService;
        _this.dialog = dialog;
        _this.schedulerApiService = schedulerApiService;
        _this.dialogRef = dialogRef;
        _this.myControl = new FormControl();
        _this.loading = false;
        _this.limit = 30;
        _this.serpCityLimit = 0;
        _this.accounts = [];
        _this.regionalAccountLimit = 30;
        _this.isSyncEventAfterAddingDMOAccounts = true;
        _this.pagesLimitSource = [];
        _this.serpBlockKeywords = [];
        _this.enteredCity = { address: '', lat: 0, lng: 0 };
        _this.timezoneSource = [];
        _this.isOpenRegionalAccountType = false;
        _this.serpGoogleType = 'city';
        _this.jobKeywords = [];
        _this.jobKeywordsDisplayText = [];
        _this.regionalAccounts = [];
        _this.selectedTabIndex = 0;
        _this.account = Object.assign({}, data);
        _this.form = _this.formBuilder.group({
            limit: [null],
            city: [null],
            eventbriteEventIdsOrUrls: [null],
        });
        return _this;
    }
    EventSpiderModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadSpiderEventPage();
        this.timezoneSource = timezoneConfig;
        this.accountApiService.getEventTimezone(this.account.account._id).subscribe(function (res) {
            if (res.timezoneFormatter) {
                _this.myControl.setValue(res.timezoneFormatter);
                _this.timezoneSource.forEach(function (item) {
                    if (item.value === res.timezoneFormatter) {
                        _this.myControl.setValue(item.name);
                    }
                });
            }
        });
        this.accountApiService.getSerpBlockKeywords().subscribe(function (blocked) {
            console.log(blocked);
            _this.serpBlockKeywords = blocked.value.split(', ');
        });
        this.accountApiService.getJobKeywords(this.account.account._id).subscribe(function (result) {
            _this.jobKeywords = result.data;
            _this.jobKeywordsDisplayText = _this.jobKeywords.map(function (x) { return x.keyword + " (" + x.city + ", " + x.state + ")"; });
        });
        this.loadIsAllowOnlineEvents();
        this.accountApiService
            .getEventCronjobLastRunTime(this.account.account.userName)
            .subscribe(function (data) {
            console.log(data);
            _this.lastRunTime = data;
        });
        this.fieldForm = this.fb.group({
            city: [null, null],
        });
        setTimeout(function () {
            _this.timezoneSourceFiltered = _this.myControl.valueChanges.pipe(startWith(''), map(function (value) { return _this._filter(value); }));
        }, 500);
        this.isOpenRegionalAccountType = this.account.account.toggle.regionalAccountType;
        this.regionalAccounts = this.account.account.regionalAccounts;
    };
    EventSpiderModalComponent.prototype.parseTime = function (time) {
        return new Date(time).toLocaleString();
    };
    EventSpiderModalComponent.prototype.loadSpiderEventPage = function () {
        var _this = this;
        this.loading = true;
        console.log('account', this.account);
        this.accountApiService.getSpiderEventPages(this.account.account._id).subscribe(function (pages) {
            _this.limit = isNullOrUndefined(pages.pagesMax) ? config.maxLocationFeedLimit : pages.pagesMax;
            _this.pages = {
                facebook: pages.pages.filter(function (x) { return x.socialName === 'facebook'; }).map(function (x) { return x.url; }),
                eventbrite: pages.pages.filter(function (x) { return x.socialName === 'eventbrite'; }),
                serpGoogle: pages.pages
                    .filter(function (x) { return x.socialName === 'serp|google'; })
                    .map(function (x) {
                    return { url: x.url, tag: x.tag };
                }),
                serpGoogleKeywords: pages.pages
                    .filter(function (x) { return x.socialName === 'serp|google|keywords'; })
                    .map(function (x) {
                    return { url: x.url, tag: x.tag };
                }),
            };
            _this.serpGoogleCityPages = _this.pages.serpGoogle.map(function (x) { return "" + x.url + (x.tag ? "(" + x.tag + ")" : ''); });
            _this.serpGoogleKeywordsPages = _this.pages.serpGoogleKeywords.map(function (x) { return "" + x.url + (x.tag ? " (" + x.tag + ")" : ''); });
            _this.loading = false;
            _this.pagesLimitSource = [
                {
                    text: 'Unlimited',
                    value: 0,
                    selected: _this.limit === 0,
                },
                {
                    text: '15',
                    value: 15,
                    selected: _this.limit === 15,
                },
                ,
                {
                    text: '30',
                    value: 30,
                    selected: _this.limit === 30,
                },
                {
                    text: '60',
                    value: 60,
                    selected: _this.limit === 60,
                },
                {
                    text: '90',
                    value: 90,
                    selected: _this.limit === 90,
                },
                {
                    text: '120',
                    value: 120,
                    selected: _this.limit === 120,
                },
                {
                    text: '150',
                    value: 150,
                    selected: _this.limit === 150,
                },
            ];
            // to ensure value is selected after dropdown init
            setTimeout(function () {
                _this.limitSelect.setSelected(_this.limit);
            }, 500);
        });
    };
    EventSpiderModalComponent.prototype.onAddKeywordsPage = function (value) {
        this.pages.serpGoogleKeywords.push({
            url: value,
            tag: this.filterCountryName(this.serpGooglekeywordsCity.address),
        });
    };
    EventSpiderModalComponent.prototype.onRemoveKeywordsPage = function (data) {
        this.pages.serpGoogleKeywords.splice(data.index, 1);
    };
    EventSpiderModalComponent.prototype.onAddJobKeywords = function (value) {
        var displayText = value + " (" + this.jobKeywordsCity.city + ", " + this.jobKeywordsCity.state + ")";
        this.jobKeywords.push({
            keyword: value,
            city: this.jobKeywordsCity.city,
            state: this.jobKeywordsCity.state,
            country: this.jobKeywordsCity.country,
        });
        // remove the last item in jobKeywordsDisplayText
        this.jobKeywordsDisplayText.splice(this.jobKeywordsDisplayText.length - 1, 1);
        this.jobKeywordsDisplayText.push(displayText);
    };
    EventSpiderModalComponent.prototype.onRemoveJobKeywords = function (data) {
        this.jobKeywords.splice(data.index, 1);
        // this.jobKeywordsDisplayText.splice(data.index, 1);
    };
    EventSpiderModalComponent.prototype.saveJobKeywords = function (event) {
        var _this = this;
        console.log(this.jobKeywordsCity);
        this.accountApiService
            .saveJobKeywords(this.account.account._id, this.jobKeywords.map(function (x) { return ({
            keyword: x.keyword,
            city: x.city,
            state: x.state,
            country: x.country,
        }); }))
            .pipe(finalize(function () {
            event.complete();
        }))
            .subscribe(function () {
            _this.alertify.success('Job keywords saved successfully');
        });
    };
    EventSpiderModalComponent.prototype.isUseOwnKeywordsChanged = function () { };
    EventSpiderModalComponent.prototype.editEventbriteCityCode = function (page) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        dialogConfig.data = page;
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.panelClass = 'width-modal-2';
        var dialogRef = this.dialog.open(SetEventPageTagModalComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (data) {
            if (data) {
                for (var i = 0; i < _this.pages.eventbrite.length; i++) {
                    if (_this.pages.eventbrite[i]._id &&
                        data._id &&
                        _this.pages.eventbrite[i]._id === data._id) {
                        _this.pages.eventbrite[i] = data;
                    }
                }
            }
        });
    };
    EventSpiderModalComponent.prototype.addEventbriteCityCode = function () {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.panelClass = 'width-modal-2';
        var dialogRef = this.dialog.open(SetEventPageTagModalComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (data) {
            if (data) {
                if (_this.pages.eventbrite.any(function (x) { return x.url === data.url; })) {
                    _this.alertify.warning('Page already exists');
                    return;
                }
                _this.pages.eventbrite.push(data);
            }
        });
    };
    EventSpiderModalComponent.prototype.removeEventbriteCityCode = function (page) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                if (page._id) {
                    _this.pages.eventbrite = _this.pages.eventbrite.filter(function (x) { return x._id !== page._id; });
                }
                else {
                    _this.pages.eventbrite = _this.pages.eventbrite.filter(function (x) { return x.url !== page.url; });
                }
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: "Are you sure you want to remove this page?",
            confirmModalConfirmButtonText: 'Yes',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: false,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    EventSpiderModalComponent.prototype._filter = function (value) {
        var filterValue = value.toLocaleLowerCase();
        return this.timezoneSource.filter(function (option) {
            return option.value.toLocaleLowerCase().includes(filterValue);
        });
    };
    EventSpiderModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    EventSpiderModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var data, custom;
            return __generator(this, function (_a) {
                data = this.pages.facebook.map(function (x) {
                    x = x.replace('?ref=page_internal', '');
                    return new SpiderPage('facebook', x);
                });
                data.push.apply(data, this.pages.eventbrite.map(function (x) {
                    return x;
                }));
                data.push.apply(data, this.serpGoogleCityPages.map(function (x) {
                    return new SpiderPage('serp|google', x);
                }));
                data.push.apply(data, this.pages.serpGoogleKeywords.map(function (x) {
                    return new SpiderPage('serp|google|keywords', x.url, x.tag);
                }));
                this.accountApiService
                    .setSpiderEventPages(this.account.account._id, data)
                    .finally(event.complete)
                    .subscribe(function () {
                    // this.alertify.successfully('Save events');
                    _this.dialogRef.close();
                });
                custom = this.account.account.facebookFeeds.blockKeywords;
                this.accountApiService
                    .setSerpBlockKeywords(custom.isUseOwn ? custom.keywords : this.serpBlockKeywords, {
                    userName: this.account.account.userName,
                    isUseOwn: custom.isUseOwn,
                })
                    .subscribe();
                if (this.isOpenRegionalAccountType) {
                    this.accountApiService
                        .setRegionalAccounts(this.account.account.userName, this.regionalAccounts, this.isSyncEventAfterAddingDMOAccounts)
                        .subscribe(function (data) {
                        if (!data.success) {
                            _this.alertify.error(data.msg);
                        }
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    EventSpiderModalComponent.prototype.setLimit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.accountApiService
                    .setEventPagesLimit(this.account.account._id, this.limit)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.alertify.successfully('Set page limit');
                    _this.dialogRef.close();
                });
                return [2 /*return*/];
            });
        });
    };
    EventSpiderModalComponent.prototype.limitChanged = function (value) {
        this.limit = value.value;
    };
    EventSpiderModalComponent.prototype.pullEventbriteEvent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var eventIds, processedEventIds;
            return __generator(this, function (_a) {
                this.errorMessage = '';
                if (!this.eventbriteEventIdsOrUrls) {
                    event.complete();
                    return [2 /*return*/];
                }
                eventIds = this.eventbriteEventIdsOrUrls.includes(';')
                    ? this.eventbriteEventIdsOrUrls.split(';')
                    : [this.eventbriteEventIdsOrUrls];
                eventIds = eventIds.map(function (id) { return id.trim(); });
                processedEventIds = eventIds
                    .map(function (id) {
                    id = id.trim();
                    var eventId = '';
                    if (_this.isUrl(id)) {
                        var parsed = EventSpiderModalComponent.parseEventbriteUrl(id);
                        if (parsed && parsed.eventId) {
                            eventId = parsed.eventId;
                        }
                    }
                    else {
                        eventId = id;
                    }
                    return eventId;
                })
                    .filter(function (x) { return x; });
                if (processedEventIds.length === 0) {
                    event.complete();
                    this.errorMessage = 'No valid eventbrite event id or url found';
                    return [2 /*return*/];
                }
                this.accountApiService
                    .getEventbriteEvents(this.account.account._id, processedEventIds)
                    .finally(event.complete)
                    .subscribe(function (res) {
                    if (res && res.error) {
                        _this.errorMessage = 'Pull eventbrite events error: ' + res.error + '.';
                    }
                    else {
                        if (res && res.events && res.events.length) {
                            var actions = {
                                confirm: function (buttonEvent) {
                                    _this.eventbriteEventIdsOrUrls = '';
                                    buttonEvent.complete();
                                },
                                cancel: function () { },
                            };
                            _this.modalService.show({
                                component: AddEventbriteEvenetsModalComponent,
                                providers: [
                                    { provide: AddEventbriteEventsModalActions, useValue: actions },
                                    {
                                        provide: AddEventbriteEventsModalData,
                                        useValue: new AddEventbriteEventsModalData(_this.account.account, res.events),
                                    },
                                ],
                                panelClass: 'width-modal-90p',
                            });
                        }
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    EventSpiderModalComponent.prototype.changeAllowOnlineEvents = function () {
        var _this = this;
        this.accountApiService
            .setIsAllowOnlineEvents(this.account.account._id, this.isAllowOnlineEvents)
            .subscribe(function () {
            _this.alertify.successfully("Set " + (_this.isAllowOnlineEvents ? 'allow' : 'not allow') + " online events");
        });
    };
    EventSpiderModalComponent.prototype.loadIsAllowOnlineEvents = function () {
        var _this = this;
        this.accountApiService.getIsAllowOnlineEvents(this.account.account._id).subscribe(function (data) {
            _this.isAllowOnlineEvents = data.isAllowOnlineEvents || false;
        });
    };
    EventSpiderModalComponent.prototype.setTimezone = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.accountApiService
                    .setEventTimezone(this.account.account._id, this.myControl.value.split(' ')[0])
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.alertify.successfully('Set event timezone');
                    _this.dialogRef.close();
                });
                return [2 /*return*/];
            });
        });
    };
    EventSpiderModalComponent.prototype.testSerpGoogle = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var serpCityToAdd, serpConfig;
            return __generator(this, function (_a) {
                // const serpCityToAdd = this.serpCityMultipleFields.getText();
                if (!this.enteredCity || !this.enteredCity.address) {
                    $event.complete();
                    alert('Please enter a city, e.g., Savannah, GA');
                    return [2 /*return*/];
                }
                serpCityToAdd = this.enteredCity.address;
                serpCityToAdd = serpCityToAdd.toLocaleLowerCase().replaceAll(', usa', '');
                serpConfig = new SerpConfig(false, 0, 0, true);
                this.schedulerApiService
                    .serpApi(this.account.account.userName, serpCityToAdd, serpConfig)
                    .finally($event.complete)
                    .subscribe(function (result) {
                    console.log(result);
                    if (!result || !result.success) {
                        alert(result.msg);
                        return;
                    }
                    if (!result.events.length) {
                        alert("No events found");
                        return;
                    }
                    result.events.forEach(function (x) { return EventTimeService.processEventTime(x, false); });
                    var page = [{ events: result.events, pageLink: serpCityToAdd }];
                    _this.modalService.show({
                        component: AddSpiderEvenetsModalComponent,
                        providers: [
                            { provide: AddSpiderEventsModalActions, useValue: null },
                            {
                                provide: AddSpiderEventsModalData,
                                useValue: new AddSpiderEventsModalData(_this.account.account.userName, [], page, '', true),
                            },
                        ],
                        panelClass: 'width-modal-90p',
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    EventSpiderModalComponent.prototype.citySelected = function () {
        if (this.enteredCity && this.enteredCity.address) {
            var filtered = this.enteredCity.address.replaceAll(', USA', '').replace(/\d+/g, '');
            this.serpCityMultipleFields.setText(filtered);
            this.enteredCity.address = filtered;
        }
    };
    EventSpiderModalComponent.prototype.testSerpGoogleKeywords = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var city, serpCityToAdd, serpConfig;
            return __generator(this, function (_a) {
                if (!this.keywordsMultipleFields.text) {
                    $event.complete();
                    alert('Please enter a keywords to test, e.g., Cincinnati red events');
                    return [2 /*return*/];
                }
                if (!this.serpGooglekeywordsCity) {
                    $event.complete();
                    alert('Please enter a city to filter events (events in this city will be pulled), e.g., Savannah, GA');
                    return [2 /*return*/];
                }
                console.log('this.this.keywordsMultipleFields.text', this.keywordsMultipleFields.text);
                city = this.filterCountryName(this.serpGooglekeywordsCity.address);
                console.log('this.serpGooglekeywordsCity', city);
                serpCityToAdd = this.enteredCity.address;
                serpCityToAdd = serpCityToAdd.toLocaleLowerCase().replaceAll(', usa', '');
                serpConfig = new SerpConfig(false, 0, 0, true, 'keywords', this.keywordsMultipleFields.text);
                this.schedulerApiService
                    .serpApi(this.account.account.userName, city, serpConfig)
                    .finally($event.complete)
                    .subscribe(function (result) {
                    console.log(result);
                    if (!result || !result.success) {
                        alert(result.msg);
                        return;
                    }
                    if (!result.events.length) {
                        alert("No events found");
                        return;
                    }
                    result.events.forEach(function (x) { return EventTimeService.processEventTime(x, false); });
                    var page = [{ events: result.events, pageLink: serpCityToAdd }];
                    _this.modalService.show({
                        component: AddSpiderEvenetsModalComponent,
                        providers: [
                            { provide: AddSpiderEventsModalActions, useValue: null },
                            {
                                provide: AddSpiderEventsModalData,
                                useValue: new AddSpiderEventsModalData(_this.account.account.userName, [], page, '', true),
                            },
                        ],
                        panelClass: 'width-modal-90p',
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    EventSpiderModalComponent.prototype.onAddRegionalAccount = function (value) { };
    EventSpiderModalComponent.prototype.tabChanged = function ($event) {
        var _this = this;
        this.selectedTabIndex = $event;
        // select Regional account feature, load the accounts for autocomplete
        if ($event === 3 && !this.accounts.length) {
            this.accountApiService.getAccounts().subscribe(function (accounts) {
                _this.accounts = accounts
                    .filter(function (x) {
                    return x.status === 'live' &&
                        !x.isAdministrator &&
                        x.userName !== _this.account.account.userName;
                })
                    .map(function (x) { return x.userName; });
            });
        }
    };
    EventSpiderModalComponent.prototype.filterCountryName = function (address) {
        return address.replaceAll(', USA', '').replace(/\d+/g, '');
    };
    EventSpiderModalComponent.parseEventbriteUrl = function (url) {
        try {
            var parsedUrl = new URL(url);
            var path = parsedUrl.pathname; // /e/event-title-words-registration-1224372183159
            // Match the final "event_id" (number) with the middle "title"
            var match = path.match(/\/e\/(.+?)-(\d+)(?:\/|$|\?)/);
            if (match) {
                var rawTitle = match[1];
                var eventId = match[2];
                // Convert the event title from URL format to a readable format
                var eventTitle = rawTitle
                    .replace(/-registration$/, '') // Remove "registration" at the end if it exists
                    .replace(/-/g, ' ')
                    .replace(/\b\w/g, function (char) { return char.toUpperCase(); });
                return { eventId: eventId, eventTitle: eventTitle };
            }
            else {
                return '';
            }
        }
        catch (err) {
            return '';
        }
    };
    EventSpiderModalComponent.prototype.isUrl = function (str) {
        try {
            var testStr = str.trim().startsWith('http://') || str.trim().startsWith('https://')
                ? str.trim()
                : 'https://' + str.trim();
            var url = new URL(testStr);
            return url.protocol === 'http:' || url.protocol === 'https:';
        }
        catch (_a) {
            return false;
        }
    };
    return EventSpiderModalComponent;
}(BaseComponent));
export { EventSpiderModalComponent };
var SpiderPage = /** @class */ (function () {
    function SpiderPage(socialName, url, tag) {
        if (tag === void 0) { tag = ''; }
        this.socialName = socialName;
        this.url = url;
        this.tag = tag;
    }
    return SpiderPage;
}());
export { SpiderPage };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/event.spider/event.spider.modal.component.ts.pre-build-optimizer.js